import { render, staticRenderFns } from "./private-message.vue?vue&type=template&id=4f350262&scoped=true&"
import script from "./private-message.vue?vue&type=script&lang=js&"
export * from "./private-message.vue?vue&type=script&lang=js&"
import style0 from "./private-message.vue?vue&type=style&index=0&id=4f350262&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f350262",
  null
  
)

export default component.exports